import React, {Component} from 'react';
import './style.less';
import mobx from 'mobx';
import Icon from '../Icon';
import {observer} from "mobx-react";
// import {routes} from '../../../app-routes';

@observer
class RefBoxForReportForms extends Component {

  handleClick = (e) => {
    e.preventDefault();
    if(this.props.onClick){
      this.props.onClick({...this.props});
    }
  }

  render() {
    const {
      mode,
      value
    } = this.props;
    let showValue = mode ==='single'?(value && value.text):mode==='range'?(value[0] || {}).text:value.map(it=>it.text).join(';');
    return (
      <div className='refBox' onClick={this.handleClick}>
        <span className={`val ${showValue ? '' : 'val-not'}`}>{showValue || '请选择'}</span>
        <Icon type='gengduo' className='gengduo-icon' />
      </div>
    )
  }



}



export default RefBoxForReportForms;
